<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Concierge'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" (contentHeight)="contentHeight = $event" [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService.isDesktopRes && !isRightSideContent) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Concierge'" />
        </div>
      </tidy-desktop-header>
    }

    <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
      <tidy-text
        header="Actions" />
      <tidy-image
        [src]="'assets/img/help-circle-outline.svg'"
        [matMenuTriggerFor]="helpMenu"
        #menuTrigger="matMenuTrigger"
        (mouseenter)="menuTrigger.openMenu()"
        (mouseleave)="menuTrigger.closeMenu()"
        style="margin-left: 5px" />
      <mat-menu #helpMenu="matMenu"
        [hasBackdrop]="false"
        class="help-hover-menu">
        <div class="help-menu-content">
          <tidy-text [body]="'Concierge actions are things you had us do on your behalf under your direction.'" />
        </div>
      </mat-menu>
      <div>
        <tidy-small-button
          [text]="'Rules'"
          [image]="'assets/img/settings-white.svg'"
          style="margin-right: 5px"
          (buttonClick)="goToSection('rules')" />
        <tidy-small-button
          [text]="'Add Action'"
          [image]="'assets/img/add-button-white.svg'"
          (buttonClick)="goToAddConciergeAction()" />
      </div>
    </tidy-row>
    @if (conciergeActionTableItems?.length == 0) {
      <tidy-alert>
        <tidy-text
          [body]="'Nothing pending'" />
      </tidy-alert>
    }
    @if (conciergeActionTableItems?.length > 0 && actionsLoaded) {
      @for (action of conciergeActionTableItems | slice:0:3; track action) {
        <tidy-card>
          <tidy-card-button (action)="goToItem('conciergeActions', action)" class="arrow-to-top">
            <tidy-row class="vertical-align-middle">
              <tidy-image
                [src]="action['Status'].value === 'Closed' ? 'assets/img/done.svg' : 'assets/img/pending.svg'"
                class="body-size" />
              <tidy-text
                [body]="action['Subject']?.value" />
            </tidy-row>
            @if (!action['Status']?.value?.includes('dispute')) {
              <tidy-row>
                <tidy-text
                  [smallHelper]="action['Status'].value + (' (updated ' | translate) + action['Last Updated'].value + ')'" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
      @if (conciergeActions?.length > 3) {
        <tidy-row class="vertical-align-center" [align]="'center'">
          <tidy-text
            [actionBody]="'View More'"
            class="link"
            (action)="goToSection('conciergeActions')"
            style="margin-right: 20px;" />
        </tidy-row>
      }
    }

    @if (!actionsLoaded) {
      <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
        <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
      </tidy-card>
      @if (!actionsLoaded) {
        <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
          <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
        </tidy-card>
      }
      @if (!actionsLoaded) {
        <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
          <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
        </tidy-card>
      }
    }

    <tidy-row class="extra-top-padding vertical-align-center" [alignLastItemRight]="true">
      <tidy-text
        header="Support Requests" />
      <tidy-image
        [src]="'assets/img/help-circle-outline.svg'"
        [matMenuTriggerFor]="supportHelpMenu"
        #supportMenuTrigger="matMenuTrigger"
        (mouseenter)="supportMenuTrigger.openMenu()"
        (mouseleave)="supportMenuTrigger.closeMenu()"
        style="margin-left: 5px" />
      <mat-menu #supportHelpMenu="matMenu"
        [hasBackdrop]="false"
        class="help-hover-menu">
        <div class="help-menu-content">
          <tidy-text [body]="'Support requests are account set up or troubleshooting requests from our team.'" />
        </div>
      </mat-menu>
      <tidy-small-button
        [text]="'Add Request'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddSupportRequest()" />
    </tidy-row>
    @if (supportRequestTableItems?.length == 0) {
      <tidy-alert>
        <tidy-text
          body="Nothing pending…" />
      </tidy-alert>
    }
    @if (supportRequestTableItems?.length > 0 && supportRequestsLoaded) {
      @for (request of supportRequestTableItems | slice:0:3; track request) {
        <tidy-card>
          <tidy-card-button (action)="goToItem('supportRequests', request)">
            <tidy-row class="vertical-align-middle">
              <tidy-image
                [src]="request['Status']?.value?.includes('dispute') ? concierge.getDisputeIcon(request['Status']?.value) : (request['Status']?.value === 'Closed' ? 'assets/img/done.svg' : 'assets/img/pending.svg')"
                class="body-size" />
              <tidy-text
                [body]="request['Subject']?.value" />
            </tidy-row>
            @if (!request['Status']?.value?.includes('dispute')) {
              <tidy-row>
                <tidy-text
                  [smallHelper]="request['Status'].value + (' (updated ' | translate) + request['Last Updated'].value + ')'" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
      @if (supportRequests?.length > 3) {
        <tidy-row class="vertical-align-center" [align]="'center'">
          <tidy-text
            actionBody="View More"
            class="link"
            (action)="goToSection('supportRequests')"
            style="margin-right: 20px;" />
        </tidy-row>
      }
    }

    @if (!actionsLoaded) {
      <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
        <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
      </tidy-card>
      @if (!actionsLoaded) {
        <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
          <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
        </tidy-card>
      }
      @if (!actionsLoaded) {
        <tidy-card style="padding: 0px; height: 70px; padding: 0px;">
          <ion-skeleton-text animated style="width: 100%; height: 70px; border-radius: 6px; margin: 0;" />
        </tidy-card>
      }
    }

    <!-- <ng-container *ngIf="selectedCategory">
    <ng-container *ngFor="let item of filteredItems">

      <ng-container *ngIf="item?.type.includes('dispute')">
        <tidy-card>
          <tidy-card-button (action)="goToDispute(item)" [hideArrow]="item?.type === 'dispute.customer_dispute_counter_response' ? true : false" [customIcon]=" item?.type === 'dispute.customer_dispute_counter_response' ? 'assets/img/play-black.svg' : ''" [customArrowPositon]="{ top: '18px', width: '11px'}">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="concierge.getDisputeIcon(item?.type)"
                class="title-size">
              </tidy-image>
              <tidy-text
                [header]="item?.header_text">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngIf="item?.type === 'dispute.customer_dispute_initiated'">
              <tidy-text
                [body]="'<i>Waiting on Pro</i>'">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngIf="item?.type === 'dispute.customer_dispute_counter_answer'">
              <tidy-text
                [body]="'<b><i>Waiting on You</i><b>'">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngIf="item?.type == 'dispute.customer_dispute_won' || item?.type == 'dispute.customer_dispute_lost'">
              <tidy-text
                [body]="'<i>Dispute Closed</i>'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </ng-container>

      <ng-container *ngIf="item?.type.includes('support')">
        <tidy-card *ngIf="item?.components[0]?.value?.status === 'waiting_on_customer'">
          <tidy-card-button (action)="goToConciergeMessage(item)" [hideArrow]="true" [customIcon]="'assets/img/play-black.svg'">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="concierge.getStatusIcon(item?.components[0]?.value?.status)"
                class="title-size">
              </tidy-image>
              <tidy-text
                [header]="(item?.metadata?.request_data?.subject | slice:0:30) + (item?.metadata?.request_data?.subject?.length > 30 ? '..' : '')">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngIf="item?.components[0]?.value?.status !== 'completed' && item?.components[0]?.value?.status !== 'closed'">
              <tidy-text
                [body]="'<b><i>Waiting on You</i><b>'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'<i>' + (item?.components[0]?.value?.last_update_at | parseDateTime:'MMM d') + '</i>'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-card *ngIf="item?.components[0]?.value?.status !== 'waiting_on_customer'">
          <tidy-card-button (action)="goToConciergeMessage(item)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="concierge.getStatusIcon(item?.components[0]?.value?.status)"
                class="title-size">
              </tidy-image>
              <tidy-text
                [header]="(item?.metadata?.request_data?.subject | slice:0:30) + (item?.metadata?.request_data?.subject?.length > 30 ? '..' : '')">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngIf="item?.components[0]?.value?.status !== 'completed' && item?.components[0]?.value?.status !== 'closed'">
              <tidy-text
                [body]="'<i>Waiting on TIDY</i>'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'<i>' + (item?.components[0]?.value?.last_update_at | parseDateTime:'MMM d') + '</i>'">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      </ng-container>
    </ng-container>
  </ng-container> -->

  <!-- <genome-items [genomeItems]="genomeItems"></genome-items> -->

</tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" [isfullWidthContent]="windowService.isDesktopRes" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

<tidy-bottom-nav activeRoute="/concierge" />
